<template>
    <div class="py-4 container-fluid">
      <div class="card">
        <div class="card-header py-3">
            <div class="row align-items-center">
                <!-- Bagian H3 di Kiri -->
                <div class="col-8">
                <h5 class="mb-0">Characteristic Value</h5>
                </div>

                <!-- Bagian Pencarian di Kanan -->
                <div class="col-4 text-end">
                <IconField class="w-100">
                    <InputIcon>
                    <i class="pi pi-search"></i>
                    </InputIcon>
                    <InputText
                    v-model="table.search"
                    type="text"
                    size="small"
                    placeholder="Search"
                    class="rounded-pill w-100"
                    @keyup="filter"
                    />
                </IconField>
                </div>
            </div>
        </div>

  
        <DataTable :value="table.data" size="null" removable-sort scrollable scroll-height="450px" table-style="min-width: 50rem">
          <Column field="inc" header="inc" header-class="bg-light text-dark" sortable>
          <Skeleton></Skeleton>
          </Column>
          <Column field="characteristic" header="Characteristic" header-class="bg-light text-dark" sortable>
          <Skeleton></Skeleton>
          </Column>
          <Column field="values" header="values" header-class="bg-light text-dark" sortable>
          </Column>
          <Column field="abbrev" header="Abbrev" header-class="bg-light text-dark" sortable>
          </Column>
          <Column field="status" header="Position Label" header-class="bg-light text-dark" sortable>
          </Column>
          <Column field="#" header="Actions" header-class="bg-light text-dark">
            <template #body="{ data }">
              <div class="dropdown text-center">
                <a id="dropdownInvent" href="#" class="cursor-pointer" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                  <i class="fa fa-ellipsis-v text-secondary"></i>
                </a>
                <ul class="dropdown-menu" aria-labelledby="dropdownInvent">
                  <li>
                    <a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#modalAddEdit" >Edit</a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click="deleteItem(data)">Delete</a>
                  </li>
                </ul>
              </div>
            </template>
          </Column>
        </DataTable>
        <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
          <BasePagination
            v-model="table.page"
            :page-count="table.page"
            size="sm"
            @click="changePage()"
          />
          <p>
            {{ (table.page - 1) * table.page + table.data.length }}
            of {{ table.total }}
          </p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        table: {
          onLoad: false,
          total: 3,
          data: [
            {
              inc: "61638",
              characteristic: "FUNCTIONALITY",
              values: "DISPLAY BOARD MULTI-STREAM",
              single_multiple: "",
              status: "Not Approved",
            },
            {
              inc: "61638",
              characteristic: "FUNCTIONALITY",
              values: "DISPLAY BOARD MULTI-STREAM",
              abbrev: "",
              status: "Not Approved",
            },
            {
              inc: "61638",
              characteristic: "FUNCTIONALITY",
              values: "DISPLAY BOARD MULTI-STREAM",
              abbrev: "",
              status: "Not Approved",
            },
          ],
        },
        modal: {
          visible: false,
          action: "",
          title: "",
          data: {},
          errorMessage: {},
          onLoading: false,
        },
      };
    },
    methods: {
      editItem(item) {
        this.modal = {
          visible: true,
          action: "edit",
          title: "Edit Item",
          data: { ...item },
          errorMessage: {},
          onLoading: false,
        };
      },
      deleteItem(item) {
      this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
        if (result.isConfirmed) {
          this.delete(item);
        }
      });
    },
    },
  };
  </script>
  